import React, { useRef, useState } from 'react';
import { uploadAdminImage } from '../../utils/adminApi';
import './ImageUrlField.css';

/**
 * URL input + Cloudinary upload button for SEO / CMS image fields.
 */
const ImageUrlField = ({
  label = 'Image URL',
  value = '',
  onChange,
  placeholder = 'https://...',
  folder = 'seo',
  hint = 'Paste a URL or upload to Cloudinary',
  showPreview = true,
}) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setError('Please choose an image file.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setError('Image must be under 5MB.');
      return;
    }

    setError('');
    setUploading(true);
    try {
      const url = await uploadAdminImage(file, folder);
      onChange(url);
    } catch (err) {
      setError(err.message || 'Upload failed.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="image-url-field">
      {label && <label className="image-url-field-label">{label}</label>}
      <div className="image-url-field-row">
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={uploading}
        />
        <button
          type="button"
          className="image-url-upload-btn"
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
        >
          {uploading ? 'Uploading…' : 'Upload'}
        </button>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="image-url-file-input"
          onChange={handleUpload}
        />
      </div>
      {hint && !error && <small className="image-url-hint">{hint}</small>}
      {error && <small className="image-url-error">{error}</small>}
      {showPreview && value ? (
        <div className="image-url-preview">
          <img src={value} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        </div>
      ) : null}
    </div>
  );
};

export default ImageUrlField;
